export class ConnectionType {
    static readonly LAN = "LAN";
    static readonly WIFI = "WIFI";
    static readonly MOBILE3G = "MOBILE3G";
    static readonly UNDETECTED = "UNDETECTED";
}